// extracted by mini-css-extract-plugin
module.exports = {"MyTrips":"MyTrips_MyTrips__3uCpp"};